<template>
  <div class="product-ccard-container">
    <div class="title">企业用户</div>
    <div class="common-search-wrap">
      <el-row :gutter="20">
        <el-col :span="18">
          <el-form size="small" ref="searchForm" :model="searchForm">
            <el-form-item label="卡金" prop="store_id">
              <el-select size="small" v-model="searchForm.companyCardId" placeholder="请选择" filterable clearable
                         @change="handleQuery">
                <el-option
                    v-for="item in cards"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-form>
        </el-col>
        <el-col :span="6" style="display: flex; align-items: center; justify-content: flex-end">
          <el-link type="primary" size="small" @click="handleDownloadTemplate" style="margin-right: 10px">下载导入模板</el-link>
          <el-upload
              class="upload-demo"
              :action="uploadUrl"
              :before-upload="handleBeforeUpload"
              :on-success="handleSuccess"
              :on-error="handleError"
              :show-file-list="false"
          >
            <el-button size="small" type="primary" :loading="uploadLoading">
              {{ uploadLoading ? '上传中...' : '导入用户' }}
            </el-button>
          </el-upload>
        </el-col>
      </el-row>
    </div>
    <el-table
      v-loading="loading"
      :data="tableData"
      :header-cell-style="{background:'#F2F2F4'}"
      style="width: 100%"
    >
      <el-table-column prop="cardInfo.name" label="卡金名称" width="200" show-overflow-tooltip></el-table-column>
      <el-table-column prop="id" label="用户ID"></el-table-column>
      <el-table-column prop="name" label="用户姓名"></el-table-column>
      <el-table-column prop="phone" label="用户手机"></el-table-column>
      <el-table-column prop="cardInfo.balance" label="卡金余额"></el-table-column>
      <el-table-column prop="cardInfo.expireTime" label="过期时间"></el-table-column>
      <el-table-column prop="addTime" label="导入时间"></el-table-column>
      <el-table-column fixed="right" label="操作" >
        <template #default="{ row }">
          <el-link style="margin-right: 15px" type="primary" @click="handleInvalidate(row)">
            卡金失效
          </el-link>
          <el-link type="primary" @click="handleDemote(row)">
            移除用户
          </el-link>
        </template>
      </el-table-column>
    </el-table>
    <!--分页-->
    <div class="pagination">
      <el-pagination
        background
        :current-page="curPage"
        layout="total, prev, pager, next, jumper"
        :page-size="pageSize"
        :total="total"
        @current-change="handleCurrentChange"
        @size-change="handleSizeChange"
      />
    </div>
  </div>
</template>

<script>
import {url} from "../../utils/index"
export default {
  components: {},
  data() {
    return {
      searchForm: {
        companyCardId: '',
      },
      tableData: [],
      /*一共多少条数据*/
      total: 0,
      /*当前是第几页*/
      curPage: 1,
      /*一页多少条*/
      pageSize: 20,
      /*是否加载完成*/
      loading: true,
      /*卡金列表*/
      cards: [],
      uploadLoading: false,
      uploadUrl: url() + "cCard/company/user/import",
    }
  },
  created() {
    this.fetchCard()
    this.fetchData()
  },
  methods: {
    fetchCard() {
      this.$http.get("cCard/company/user/card").then(({data}) => {
        this.cards = data
      })
    },
    fetchData() {
      let self = this
      let params = self.searchForm
      params.curPage = self.curPage
      params.pageSize = self.pageSize
      this.$http.get("cCard/company/user/page", {params}).then(({data}) => {
        this.tableData = data.records
        this.total = data.total
      })
      self.loading = false
    },
    /*选择第几页*/
    handleCurrentChange(val) {
      let self = this
      self.curPage = val
      self.loading = true
      self.fetchData()
    },
    /*每页多少条*/
    handleSizeChange(val) {
      this.curPage = 1
      this.pageSize = val
      this.fetchData()
    },
    /*搜索查询*/
    handleQuery() {
      this.curPage = 1
      this.tableData = []
      this.fetchData()
    },
    handleInvalidate(row) {
      this.$http.put("cCard/company/user/invalidate/" + row.id).then(({data}) => {
        this.$message.success("操作成功")
        this.fetchData()
      })
    },
    handleDemote(row) {
      this.$http.put("cCard/company/user/demote/" + row.id).then(({data}) => {
        this.$message.success("操作成功")
        this.fetchData()
      })
    },
    handleDownloadTemplate() {
      const fileUrl = 'https://www.ciaojian.com/img/tamplate/import_company_user.xlsx';
      window.open(fileUrl);
    },
    handleBeforeUpload(file) {
      // 开始上传前设置 loading 为 true
      this.uploadLoading = true;

      // 可选：在这里做文件类型、大小限制等校验
      const isValidType = file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
      if (!isValidType) {
        this.$message.error('只能上传 Excel 文件');
        this.uploadLoading = false;
        return false; // 阻止上传
      }

      return true; // 返回 true 才会继续上传
    },
    handleSuccess(response, file) {
      if (response.code === 200) {
        this.$message.success('上传成功');
        this.fetchData()
      } else {
        this.$message.error(response.msg);
      }
      this.uploadLoading = false;
    },
    handleError(error, file) {
      this.$message.error('上传失败，请重试');
      this.uploadLoading = false;
    }
  },
}
</script>
<style scoped lang="less">
.title {
  font-size: 1.17em;
}

.common-search-wrap, .pagination {
  padding-top: 20px;
}

.pagination {
  text-align: center;
}
</style>
